import { render, staticRenderFns } from "./LoadingEffect.vue?vue&type=template&id=7ca4ff2f&scoped=true"
import script from "./LoadingEffect.vue?vue&type=script&lang=js"
export * from "./LoadingEffect.vue?vue&type=script&lang=js"
import style0 from "./LoadingEffect.vue?vue&type=style&index=0&id=7ca4ff2f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca4ff2f",
  null
  
)

export default component.exports